import ServiceCardV2 from '../ServiceCardV2'
import './styles.scss'

import missionIcon from '../../Assets/Images/mission-icon.png'
import vissionIcon from '../../Assets/Images/vision-icon.png'
import contactUsIcon from '../../Assets/Images/contact-us-icon.png'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../constants'
import { useInView } from '../../Hooks/useInView'

const UnbeatableSection = () => {
  const navigate = useNavigate()
  const [ref, inView] = useInView()

  const goToAboutUs = () => navigate(ROUTES.about)

  const goToContactUs = () => navigate(ROUTES.contact)

  const goToTrackIt = () => navigate(ROUTES.trackIt)

  return (
    <section ref={ref} className="unbeatable-section">
      <div className={`info reveal fade-left${inView ? ' visible' : ''}`}>
        <h2>Unbeatable Courier Services</h2>

        <p>
          When you need it there today and not overnight, your shipment will be
          picked up and delivered across Maryland or out of state on a direct
          delivery.
        </p>
      </div>

      <div className={`service-cards reveal fade-right delay-2${inView ? ' visible' : ''}`}>
        <ServiceCardV2
          label="Tracking"
          icon={<img src={missionIcon} alt="" />}
          onClick={goToTrackIt}
        />

        <ServiceCardV2
          label="Read More"
          icon={<img src={vissionIcon} alt="" />}
          onClick={goToAboutUs}
        />

        <ServiceCardV2
          label="Contact Us"
          icon={<img src={contactUsIcon} alt="" />}
          onClick={goToContactUs}
        />
      </div>
    </section>
  )
}

export default UnbeatableSection
